import { useContext } from "react";
import axios, { AxiosRequestConfig, HttpStatusCode } from "axios";
import AuthContext from "common/store/AuthContext";

import { generateErrorMsg, getServerUrl } from "utils/commonTools";
import { useGetPrint } from "./useGetPrint";
import { getPrintResult } from "../types/getPrintResult";
import { toJapaneseDate, createFileNameDate } from "utils/DateTools";

//--------------------------------------
// 問合せ苦情要望一覧の印刷
//--------------------------------------
export const useInquiryReport = () => {
  const authCtxt = useContext(AuthContext);
  const { token } = authCtxt;

  const { initiateDownload } = useGetPrint();

  const getInquiryReort = async (
    startDate: Date,
    endDate: Date,
    title: string
  ): Promise<getPrintResult> => {
    const config = {
      headers: { "Content-type": "application/json", Authorization: `Bearer ${token}` },
      responseType: "blob",
      params: {
        from: toJapaneseDate(startDate),
        to: toJapaneseDate(endDate),
      },
    } as AxiosRequestConfig;

    const parkId = authCtxt.selectedPark?.parkId;
    const parkName = authCtxt.selectedPark?.parkName;

    try {
      const response = await axios.get(getServerUrl() + `print/inquiry/${parkId}`, config);
      if (response.status === HttpStatusCode.NoContent) {
        return {
          succeeded: false,
          msg: "レポートを生成できませんでした（帳票が未登録です）",
        };
      }
      const url = window.URL.createObjectURL(response.data);

      const fileName = `${title}_${parkName}_${createFileNameDate(startDate)}_${createFileNameDate(
        endDate
      )}.xlsx`;
      initiateDownload(url, fileName);
      return { succeeded: true, msg: "" };
    } catch (error) {
      var errMsg = generateErrorMsg(error);
      return { succeeded: false, msg: errMsg };
    }
  };

  return { getInquiryReort };
};
